import "./ForgetPassword.css";
import "../components/fonts.css";
import logo from "../assets/logo.png";
import Submit_button from "../components/submit_button.js";
import Header from "../components/header.js";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, Toast, Toaster } from "react-hot-toast";

function ForgetPassword() {
  const [password, SetPassword] = useState("");
  const [Confirmpassword, SetConfirmpassword] = useState("");
  const [code, SetCode] = useState("");
  const navigate = useNavigate();

  const handleCodeInputChange = (event) => {
    SetCode(event.target.value);
  };

  const handlePasswordInputChange = (event) => {
    SetPassword(event.target.value);
  };

  function handleConfirmPasswordInputChange(event) {
    SetConfirmpassword(event.target.value);
  }

  const handleSubmit = () => {
    if (code.length === 0) {
      toast.error("Please enter your code !");
    } else if (password.length === 0) {
      toast.error("Please enter your password !");
    } else if (Confirmpassword.length === 0) {
      toast.error("Please enter your confirmed password !");
    } else if (Confirmpassword !== password) {
      toast.error("Your confirmed password don't match !");
    } else {
      navigate("/phone");
    }
  };

  return (
    <>
      <Header user="influencer" title="" />
      <div className="Signin">
        <Toaster toastOptions={{ duration: 2000 }} />
        <img className="Happer_image" src={logo} alt="Happer LOGO" />
        <p className="hint_text">
          insérez le code recu sur votre numéro de téléphone<br></br>
          et votre nouveau mot de passe
        </p>
        <input
          type="text"
          name="phone-number"
          value={code}
          onChange={handleCodeInputChange}
          placeholder="Code verification OTP"
          required
        />
        <input
          type="password"
          name="phone-number"
          value={password}
          onChange={handlePasswordInputChange}
          placeholder="Nouveau mot de passe"
          required
        />
        <input
          type="password"
          name="phone-number"
          value={Confirmpassword}
          onChange={handleConfirmPasswordInputChange}
          placeholder="Re-saissez nouveau mot de passe"
          required
        />
        <Submit_button title="Valider" onClick={handleSubmit} />
      </div>
      <div style={{ marginBottom: "140px" }}></div>
    </>
  );
}

export default ForgetPassword;
